import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import 'react-day-picker/dist/style.css';
import { IFiltersExecutive } from '../../../../interfaces/excecutive/IFiltersExecutive';
import CallTracking from '../components/excecutive/PromptTracking';
import MonthToDateUsage from '../components/excecutive/MonthToDateUsage';
// import DrillDetails from '../components/excecutive/DrillDetails';
import Button from '../../../../shared/button';
import DateRangePopover from '../components/DateRange';
import moment from 'moment';
import { useGetCallAnalyticsQuery } from '../../../../store/excecutive/executiveApi';

const ExecutiveTab = () => {
    const [filters, setFilters] = useState<IFiltersExecutive>({
        platform: 'all',
        competitor: '',
        date: [],
    });
	const { data: analytics, isFetching, isLoading } = useGetCallAnalyticsQuery(filters.date);
    const { control, handleSubmit } = useForm<IFiltersExecutive>();

    const onSubmit = (data: IFiltersExecutive) =>
        setFilters({
            ...data,
            date: data.date?.map(d => moment(d).format('YYYY-MM-DD'))
        });

    return (
        <>
            <div className={`border-t py-5 my-3`}>
                <MonthToDateUsage filters={filters} />
                <CallTracking
                    filters={filters}
					          analytics={analytics}
                    rightNode={
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            className="flex flex-col md:flex-row mt-0">
                            <Controller
                                name="date"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <DateRangePopover
                                        label=""
                                        value={value?.length === 2
                                            ? [new Date(value[0]), new Date(value[1])]
                                            : null}
                                        onChange={onChange}
                                    />
                                )}
                            />
                            <Button
                                loading={isFetching && !isLoading}
                                disabled={isFetching}
                                label="Show Now"
                                className="btn-primary h-9 !font-normal w-28 shrink-0 mt-1 ml-2"
                                type="submit"
                            />
                        </form>
                    }
                />
                {/* <VisibilityScore filters={filters} /> */}
                {/* <DrillDetails showFilters={false} changeTab={changeTab} /> */}
            </div>
        </>
    );
};
export default ExecutiveTab;
